import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Paper, } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import { IoIosSearch } from "react-icons/io";
import {
    Stack,
    Pagination,
} from "@mui/material";
import { APIPath,token } from "../../config/api";
import AddCurrency from "./AddCurrency";
import { Edit } from "@mui/icons-material";

const StyledTableContainer = styled(TableContainer)(({ theme, open }) => ({
    marginTop: "1%",
    marginLeft: open ? theme.spacing(29) : theme.spacing(7),
    width: open ? "80%" : "94%",
    height: "100vh",
    transition: "margin-left 0.3s ease",
    background: "rgba(204,204,204,0.2)",
    padding: "1rem 1rem 1rem 1rem",
    boxShadow: "none",
}));
const StyledPaginationContainer = styled("div")({
    background: "#fff",
    margin: "2rem auto 0 auto;",
    zIndex: 1,
    background: "none",
    display: "flex",
    justifyContent: "center"
});

const CurrencyList = ({ open }) => {
    const [currencyForm, setCurrencyForm] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [currencyList, setCurrencyList] = useState(null);
    const [searchText, setsearchText] = React.useState('');
    const [editedCurrency,setEditedCurrency]=useState(null);

    const getCurrencyList = () => {
        setIsLoading(true)
        fetch(`${APIPath}/api/v1/agency/currency`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            method: 'GET',
            mode: 'cors',
        })
            .then((res) => res.json())
            .then((data) => {
                setCurrencyList(data.data)
                setIsLoading(false)
            })
            .catch((err) => {
                alert(err)
                setIsLoading(false)
            })
    }

    useEffect(() => {
        getCurrencyList();
    }, [])
    const onClose = () => {
        setCurrencyForm(false);
        setEditedCurrency(null);
    }
    const onShow = () => {
        setCurrencyForm(true)
    }
    const filterdata =currencyList && currencyList?.filter(item =>
        item.code?.toLowerCase().includes(searchText.toLowerCase())
    );

    const deleteCurrency = (id) => {
        let confirm = window.confirm("Are you sure you want to delete this Currency?");
        if (confirm) {
            setIsLoading(true);
            fetch(`${APIPath}/api/v1/agency/currency?id=${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                method: 'DELETE',
                mode: 'cors',
            })
                .then((res) => res.json())
                .then((data) => {
                    alert("Currency deleted");
                    getCurrencyList();
                    setIsLoading(false)
                })
                .catch((err) => {
                    alert(err)
                    setIsLoading(false)
                })

        }
        else {
            setIsLoading(false);
            return
        }
    }

    const Uppercase = (str) => str.toUpperCase();
    const capitalize = (str) => {
        if (typeof str !== 'string') return '';
        return str?.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    return (
        <>
            <StyledTableContainer component={Paper} open={open}>
                <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 20px" }}>
                    <h2 style={{ fontSize: "18px" }}>Currency List</h2>
                    <button className="add-hotel"
                        onClick={onShow}
                    >Add Currency</button>
                </div>
                <div className="package-search-table" style={{ paddingBottom: "2rem" }}>
                    <div className="package-search">
                        <input type="text" placeholder="Search.."
                            value={searchText} onChange={(e) => {
                                setsearchText(e.target.value)
                            }}
                        />
                        <IoIosSearch style={{ cursor: "pointer", color: "skyblue" }} />
                    </div>
                    <div className="package-table" style={{
                        borderBottomRightRadius: "20px",
                        borderBottomLeftRadius: "20px",
                    }}>
                        <table>
                            <thead>
                                <tr>
                                    <th>Sl No.</th>
                                    <th>Currency </th>
                                    <th>Value</th>
                                    <th>Markup</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            {isLoading ? <div className="loader"></div> :
                                <>
                                    <tbody>
                                        {filterdata?.length > 0 ?
                                        ( filterdata?.map((val, id) => {
                                            return <>
                                                <tr key={id}>
                                                    <td>{id + 1}</td>
                                                    <td>{val.code}</td>
                                                    <td>{val.rate}</td>
                                                    <td>{val.markupValue}</td>
                                                    {/* <td>{capitalize(val.zoneName)}</td> */}
                                                    <td>
                                                        <button id="country-delete"
                                                        onClick={() => {
                                                            deleteCurrency(val._id)
                                                        }}
                                                       >
                                                        <img src="./deleteicon.svg" />
                                                    </button>
                                                    <button id="country-delete" style={{ marginLeft: "10px" }}
                                                    onClick={() => {
                                                        setEditedCurrency(val);
                                                        setCurrencyForm(true);
                                                    }}
                                                    >
                                                        <Edit style={{ color: "gray", cursor: "pointer" }} />
                                                    </button>
                                                    </td>
                                                </tr>
                                            </>
                                        })) : <tr><td colSpan={5} style={{ textAlign: "center" }}>No data found</td></tr>}
                                    </tbody>
                                </>}
                        </table>
                    </div>
                </div>
            </StyledTableContainer>
            {currencyForm &&
            <AddCurrency onClose={onClose}
            onShow={onShow}
            getCurrencyList={getCurrencyList}
            editaedCurrency={editedCurrency}
            />}
        </>
    );
}

export default CurrencyList;
